<template>
    <a-modal v-model="visible" title="导入商户" :width="500" centered :confirmLoading="loading" @ok="doValidate()">
        <a-space direction="vertical" align="center" style="width:100%;">
            <a-upload-dragger :multiple="false" :header="header" :accept="accept" :action="action" :file-list="fileList"
                :remove="handleRemove" :before-upload="beforeUpload" style="width:100%;">
                <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">
                    点击选择文件
                </p>
                <p class="ant-upload-hint">
                    也可以拖拽文件到这里进行上传,支持excel格式的文件
                </p>
            </a-upload-dragger>
            <a-button type="primary" @click="downTemp()">下载模板</a-button>
        </a-space>

    </a-modal>
</template>

<script>
import request, { getUploadUrl, getHeader, doImport } from '@/config/request';
import utils from '@/common/utils';
export default {
    data() {
        return {
            visible: false,
            //只能选择excel文件
            accept: '.xlsx,.xls',
            loading: false,
            action: getUploadUrl(),
            header: getHeader(),
            fileList: [],
            uploading: false,
        }
    },
    methods: {
        doValidate() {
            if (this.fileList.length < 1) {
                utils.error('请选择文件！');
                return;
            }
            this.loading = true;
            doImport('/platform/store/import', this.fileList[0], '商户导入结果').then(() => {
                this.visible = false;
                this.$emit('success');
                utils.success('导入完成')
            }).finally(() => {
                this.loading = false;
            })
        },
        downTemp() {
            request.export('/platform/store/getTemplate', {});
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file];
            return false;
        },
        show() {
            this.fileList = [];
            this.visible = true;
        }
    }
}
</script>

<style></style>